// http://stackoverflow.com/questions/33505992/babel-6-changes-how-it-exports-default

const lib = require("./build")
module.exports = lib.default



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-popover/index.js
// module id = b96D
// module chunks = 1